import type { TFunction } from 'i18next';
import { isApiError } from './api';

/** Human message for any error, preferring the API's machine-readable code. */
export function describeError(error: unknown, t: TFunction): string {
  if (isApiError(error)) {
    const key = `errors.${error.code}`;
    const translated = t(key);
    if (translated !== key) return translated;
    return error.message;
  }
  if (error instanceof TypeError) return t('errors.NETWORK');
  return t('app.error');
}

/** Per-field messages from a 422, keyed by field name; empty for any other error. */
export function fieldErrorsOf(error: unknown): Record<string, string> {
  return isApiError(error) ? error.fieldErrors : {};
}
